import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as styles from './Radio.scss';

/**
 * @class Radio
 * @classdesc Reusable Radio Component
 * @property {Object} state
 * @example ./Radio.md
 */
export default class Radio extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    selected: PropTypes.bool.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    radioGroup: PropTypes.bool,
    text: PropTypes.string,
    style: PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
    ),
    wrapperClassName: PropTypes.string,
  };

  static defaultProps = {
    className: null,
    disabled: false,
    name: '',
    text: '',
    radioGroup: false,
    style: null,
    wrapperClassName: null,
  };

  constructor(props) {
    super(props);
    const { selected } = this.props;
    this.state = {
      selected,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.selected !== prevState.selected) return { selected: nextProps.selected };
    return null;
  }

  changeHandler = e => {
    const { onChange, radioGroup } = this.props;
    const { selected } = this.state;

    return onChange(radioGroup ? e.target.name : !selected);
  };

  render() {
    const { className, disabled, name, style, text, wrapperClassName } = this.props;
    const { selected } = this.state;

    return (
      <div className={classNames(styles.radio, wrapperClassName)} style={style}>
        <input
          className={classNames(styles.radioBtn, className)}
          type="radio"
          id={name}
          onClick={this.changeHandler}
          onChange={this.changeHandler}
          checked={selected}
          name={name}
          disabled={disabled}
        />
        {text && <label htmlFor={name} className={styles.radioLabel}>{text}</label>}
      </div>
    );
  }
}
